var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{attrs:{"at-end":_vm.atEnd,"error":_vm.engine.error,"fetch-more-items":_vm.fetchMoreItems,"item-name":_vm.itemName,"items":_vm.engine.items,"loading":_vm.engine.loading},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._t("item",function(){return [_c('pre',[_vm._v(_vm._s(item))])]},{"item":item})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }